/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import classnames from 'classnames';

import NoteModel from '../../models/NoteModel';
import { RelativeDate } from '../localization/LocalizedDate';
import HealthEntryMetaIcons from '../views/components/attributes/HealthEntryMetaIcons';

interface Props {
  note: NoteModel;
  widthOffset: number;
  flaggedStyle: object;
  flaggedClassName: string;
  hideFlagged: boolean;
  titleClassName: string;
  subTextClassName: string;
  languageCode?: string;
}

const NoteListItem = (props: Props) => {
  const summaryText = props.note.getSummaryText();

  return (
    <div className="cmp-note-list-item" style={{ width: `calc(100% - ${props.widthOffset}px)` }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div className={classnames("cmp-note-list-item-title", props.titleClassName)}>
          {props.note.getTruncatedText()}
        </div>
        <div style={{ marginTop: 4 }}>
          <HealthEntryMetaIcons
            hasComments={false}
            hasAttachments={false}
            isFlagged={!props.hideFlagged && props.note.isFlagged()}
          />
        </div>
      </div>

      <div className={classnames("cmp-note-list-item-sub", props.subTextClassName)}>
        <div className="cmp-note-list-item-details font-color-gsDark">
          <div>
            <RelativeDate date={props.note.getDate()} precision={props.note.getDatePrecision()} dateKind="medium" languageCode={props.languageCode} />
          </div>
          {
            summaryText && (
              <div className="cmp-note-list-item-summary">
                {summaryText}
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
};

export const ProfileNoteListItem = (props) => (
  <NoteListItem
    flaggedClassName="bkgd-color-profile-highlight"
    hideFlagged={false}
    titleClassName="font-subhead"
    subTextClassName="font-caption-1"
    {...props}
  />
);

export const ProfileNoteListItemFlaggedRight = (props) => (
  <NoteListItem
    flaggedClassName="bkgd-color-profile-highlight cmp-note-list-item-flagged-right"
    hideFlagged={false}
    titleClassName="font-body"
    subTextClassName="font-caption-1"
    {...props}
  />
);

export const ShareCardSummaryNoteListItem = (props) => (
  <NoteListItem
    hideFlagged
    titleClassName="font-body"
    subTextClassName="font-caption-1"
    {...props}
  />
);

export const ShareCardEditNoteListItem = (props) => (
  <NoteListItem
    hideFlagged={false}
    titleClassName="font-body"
    subTextClassName="font-caption-1"
    flaggedClassName="bkgd-color-profile-highlight"
    {...props}
  />
);

export default NoteListItem;
